import { createStore, combineReducers, applyMiddleware } from "redux";
import { userData } from "./state/user/userreducers";
import {  persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { files } from "./state/files/filereducers";
import { eventLogFiles } from "./state/eventlogfiles/eventlogfilesreducers";
import { tooltips } from "./state/tooltips/tooltipreducers";
import { changelog } from "./state/changelog/changelogreducers";
import { remoteDeviceData } from "./state/remotedevice/remotedevicereducers";
import { dashboardData } from "./state/dashboard/dashboardreducers";
import { roleData } from "./state/role/rolereducers";
import { permissionData } from "./state/permissions/permissionsreducers";
import { elevationData } from "./state/elevation/elevationreducers";
import { userPermissionRoleData } from "./state/userpermissions/permissionsreducers";
import { controllerPermissionData } from "./state/controllerpermissions/controllerpermissionsreducers";
import { interpretationFileData } from "./state/interpretationfile/interpretationfilereducers";
import { unitAndEnumData } from "./state/unitsandenums/unitsandenumsreducers";
import { enumData } from "./state/enums/enumsreducers";
import { enumGroupData } from "./state/enumsgroup/enumsgroupreducers";
import { accessCodeData } from "./state/accesscode/accesscodereducers";
import { autoCompleteData } from "./state/autocomplete/autocompletereducers";

const reducers = { userData, files, eventLogFiles, tooltips, changelog, remoteDeviceData, dashboardData, roleData, permissionData, elevationData, userPermissionRoleData, controllerPermissionData, interpretationFileData, unitAndEnumData, enumData, enumGroupData, accessCodeData, autoCompleteData };

const rootReducer = combineReducers(reducers);

const persistConfig = {
  key: "root",
  storage,
  stateReconciler: autoMergeLevel2,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const configureStore = () =>
  createStore(persistedReducer, composeWithDevTools(applyMiddleware(thunk)));
